import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_REFERENCE_ID_EXIST = "GET_REFERENCE_ID_EXIST";

export const service = async (data) => {
  const options: object = {
    url: `/Api/ExternalAudit/IsReferenceIdExist/${data.referenceId}/${data.auditId}`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_REFERENCE_ID_EXIST, service, mock);
